import React, {
  FC, useState,
} from 'react';
import {
  Column, Row,
} from '../../Styles';
import Checkbox from '../../../../../../../components/Checkbox';
import TermsConditionsModal from '../../../../../Common/TermsConditionsModal';
import ColumnCenter from '../../../../../../../components/Layout/ColumnCenter';
import InterRegularText from '../../../../../../../components/Text/InterRegularText';
import InterMediumItalicText from '../../../../../../../components/Text/InterMediumItalicText';

const Terms: FC<Props> = ({
  isEnglish,
  formError,
  checkbox,
  setCheckbox,
}) => {
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);

  return (
    <>
      {
        showTermsModal && (
          <TermsConditionsModal
            callback={() => {
              setCheckbox(true);
              setShowTermsModal(false);
            }}
            showAgreeBtn={true}
            showExitBtn={false}
            isEnglish={isEnglish}
            agreeLangZH={'同意'}
          />
        )
      }

      <Row style={{ width: '85%', marginLeft: 'auto', marginRight: 'auto', marginTop: 30 }}>
        <ColumnCenter style={{ marginRight: 7 }}>
          <Checkbox
            checked={checkbox}
            style={{
              marginTop: isEnglish ? 1 : 2,
              borderColor: formError ? checkbox ? undefined : '#F00124' : undefined,
              borderWidth: 1,
              width: 20,
              height: 20,
            }}
            iconStyle={{
              fontSize: 15,
            }}
            onChange={setCheckbox}
          />
        </ColumnCenter>
        {
          isEnglish ? (
            <Column
              onClick={() => {
                setCheckbox(!checkbox);
              }}
            >
              <InterRegularText opacity={0.5} fontSize={12} lineHeight={16}>
                To use Foodifox, you must agree to our
              </InterRegularText>
              <InterMediumItalicText
                fontSize={12}
                lineHeight={16}
                textDecorationLine={'underline'}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowTermsModal(true);
                }}
              >
                Terms of use and Privacy Policy
              </InterMediumItalicText>
            </Column>
          ) : (
            <div
              style={{ fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, fontSize: 14, lineHeight: '20px', color: '#7F8A91' }}
              onClick={() => {
                setCheckbox(!checkbox);
              }}
            >
              为了更好地使用Foodifox智能柜，需要同意 &nbsp;
              <a
                href="javaScript:;"
                style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', textDecoration: 'underline' }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowTermsModal(true);
                }}
              >
                隐私条例与使用条款
              </a>
            </div>
          )
        }
      </Row>
    </>
  );
};

export interface Props {
  isEnglish: boolean;
  formError: boolean;
  checkbox?: boolean;
  setCheckbox: (checked: boolean) => void;
}

export default Terms;
